import { Injectable } from '@angular/core';

import { AuthStore } from '@store';

import { BaseApiPickerImpl } from '../base.api-picker';
import { GeneralManagementApi } from './general-management.api';
import { GeneralManagementMockApi } from './general-management.mock-api';

@Injectable({ providedIn: 'root' })
export class GeneralManagementApiPicker extends BaseApiPickerImpl<
  GeneralManagementApi | GeneralManagementMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: GeneralManagementApi,
    protected mockApi: GeneralManagementMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
